<div class="row" [formGroup]="autoGenerateLabelGroup">
  <div class="col-md-4 form-group">
    <label class="required-field"> Auto Generate Labels</label>:
    <select class="form-control" formControlName="autoPrint">
      <option disabled value="">
        {{ 'configuration.customerOnboarding.select' | translate }}
      </option>
      <option *ngFor="let eachListVal of autoGenerateLabelList" [value]="eachListVal">
        {{ eachListVal }}
      </option>
    </select>
  </div>

  <div class="col-12 mb-2 text-end">
    <button
      [disabled]="!(autoGenerateLabelGroup.valid && autoGenerateLabelGroup.dirty)"
      class="primary-btn mt-2"
      (click)="saveAutoGenerateLabel()">
      {{ 'global.save' | translate }}
    </button>
  </div>
</div>
